import { offlineDatabase } from '../database/offlineDatabase/offlineDatabase';
import { createOfflineCommonRepository } from './common/createOfflineCommonRepository';

export const offlinePriceTablesRepository = {
  ...createOfflineCommonRepository(() => offlineDatabase.priceTables, ['name']),
  getDefault: async () => {
    return offlineDatabase.priceTables.filter((priceTable) => priceTable.defaultTable).first();
  },
  getDefaultOrFail: async () => {
    const defaultPriceTable = await offlinePriceTablesRepository.getDefault();
    if (!defaultPriceTable) {
      throw new Error('default price table not found');
    }
    return defaultPriceTable;
  },
};
